import axios from 'axios';
import * as types from '../../../constant/actionTypes';
import { HOST, EX_DB, } from '../../../constant';

export function fetchDataError(err) {
  return {
    type: types.PREDICTION_PAGE_API_ERROR,
    payload: {
      msg: '市場預測頁面資料請求: ' + err.message + ' 請稍候再試',
    },
  };
}

export function fetchDataSuccess(response, year, month) {
  return {
    type: types.PREDICTION_PAGE_API_SUCCESS,
    payload: {
      year,
      month,
      data: response.data.data[0],
    },
  };
}

export function fetchDataRequest() {
  return {
    type: types.PREDICTION_PAGE_API_REQUEST,
  };
}

const fetchData = (company, year, month, authorization) => {
  return (dispatch) => {
    dispatch(fetchDataRequest());
    const options = {
      method: 'GET',
      headers: {
        authorization,
      },
      // url: `/data/${projectId}/${year}/${month}/prediction.json`
      url: `${HOST}/saber/report/select/${EX_DB}/${company}/prediction/monthly/${year}/${month}`,
    };
    return axios(options)
      .then(json => dispatch(fetchDataSuccess(json, year, month)))
      .catch(err => dispatch(fetchDataError(err))); // PAGE_ERROR
  };
};

export default fetchData;



// WEBPACK FOOTER //
// ./src/scenes/Prediction/actions/fetchPageApi.js